class AgreementDto {
  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class AssociatedFileCategoryDto {
  /** 文件类型 */
  fileCategory = [];

  /** 来源标识 */
  sourceIds = [];
}

class AssociatedFileDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AssociatedFilesRequestDto {
  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 文件类型：供应商合同/供应商附件/sku附件/盖章采购合同 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 来源标识：供应商Code/sku报价ID/采购订单单据NO */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseApprovalRequestDto {
  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 */
  approvalStatus = "";

  /** 业务主键 */
  businessKey = "";

  /** id */
  id = undefined;

  /** 流程实例id */
  instanceId = "";

  /** 节点编码 */
  nodeKey = "";

  /** 流程定义key */
  processKey = "";

  /** 任务id */
  taskId = "";
}

class ChangeApprovalRequestDto {
  /** 修改后快照 */
  afterSnapshot = "";

  /** 附件url */
  annexUrl = "";

  /** 审批号 */
  approvalNo = "";

  /** 修改前快照 */
  beforeSnapshot = "";

  /** 业务类型 */
  businessType = "";

  /** 差异对比 */
  contrast = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 变更原因 */
  reason = "";

  /** 来源凭据 */
  sourceNo = "";

  /** 审批状态：-1：待审核 0：已驳回 1：已通过 2：审核中 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class ChangeApprovalResponseDto {
  /** 修改后快照 */
  afterSnapshot = "";

  /** 附件url */
  annexUrl = "";

  /** 审批号 */
  approvalNo = "";

  /** 修改前快照 */
  beforeSnapshot = "";

  /** 业务类型 */
  businessType = "";

  /** 差异对比 */
  contrast = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 变更原因 */
  reason = "";

  /** 来源凭据 */
  sourceNo = "";

  /** 审批状态：-1：待审核 0：已驳回 1：已通过 2：审核中 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CheckSupplierCodeRequestDto {
  /** supplierCode集合 */
  supplierCodeColl = [];
}

class CheckWhetherExistsSettlementDto {
  /** 结算 */
  settlementMethodType = undefined;

  /** 供应商ID */
  supplierIdNames = [];
}

class Client {
  /** clientId */
  clientId = "";
}

class ClientDto {
  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** clientCode */
  clientCode = "";

  /** clientSecret */
  clientSecret = "";

  /** grantType */
  grantType = "";

  /** id */
  id = undefined;

  /** redirectUri */
  redirectUri = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** resUrls */
  resUrls = [];

  /** scope */
  scope = [];
}

class Code {
  /** code */
  code = "";
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class DailyBound {
  /** 绑定日期 */
  bindDate = "";

  /** 绑定数量 */
  boundCount = undefined;

  /** 绑定的SN码 */
  snList = [];
}

class DailyBoundSnDetailsResponseDto {
  /** 绑定的日期 */
  bindDate = "";

  /** PO单单号 */
  pono = "";

  /** sku */
  sku = "";

  /** 绑定的SN码 */
  snList = [];
}

class EcBusinessNoFlowResponseRpcDto {
  /** 业务单据号 */
  businessNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 文件名称(必须带后缀) */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** 合同备注 */
  remark = "";

  /** 签署流程ID */
  signFlowId = "";

  /** 签署流程状态 0-草稿,1-签署中,2-完成,3-撤销,5-过期,7-拒签 */
  signFlowStatus = undefined;
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class InDeliveryDetailBoxRequestDto {
  /** 箱号 */
  boxNo = "";

  /** 箱高 */
  height = undefined;

  /** 装箱明细 */
  inDetailPDAReceivingRequestDtos = [];

  /** 入库单 */
  iono = "";

  /** 箱长 */
  length = undefined;

  /** MPQ数量 */
  mpq = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 箱宽 */
  width = undefined;
}

class InDetailPDAReceivingRequestDto {
  /** fn_sku */
  fnSku = "";

  /** 实收数量/装箱数量 */
  qty = undefined;

  /** sku */
  sku = "";
}

class LoginExchangeDto {
  /** accessToken */
  accessToken = "";

  /** clientCode */
  clientCode = "";

  /** expiresIn */
  expiresIn = undefined;

  /** jobNo */
  jobNo = "";

  /** openId */
  openId = "";

  /** refreshToken */
  refreshToken = "";

  /** scope */
  scope = [];

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class NewSettlementMethodResponse {
  /** 尾款比例 */
  balanceRatio = undefined;

  /** 账期/天 */
  dayNumber = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 结算类型Code */
  settlementTypeCode = "";
}

class OrderDetailsWorkflowRequestDto {
  /** 汇率 */
  exchangeRate = undefined;

  /** 原毛利率 */
  grossMargin = undefined;

  /** 近3月均销量 */
  monthlySales = undefined;

  /** 调整毛利率 */
  newGrossMargin = undefined;

  /** 调整售价（含税） */
  newPrice = undefined;

  /** 原销售价（含税） */
  price = undefined;

  /** 售价币种 */
  priceCurrency = "";

  /** 售价调整策略 0:不变、1:上调、2:下调 */
  priceStatus = undefined;

  /** 调价申请单号 */
  pricingNo = "";

  /** 调整后采购成本率 */
  procurementCosts = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";
}

class PadQuerySnResponseDto {
  /** 每日绑定SN */
  dailyBoundResponseDtos = [];

  /** 总绑定数量 */
  totalBindCount = undefined;
}

class PrcocurementOrderDetailsWorkflowRequestDto {
  /** 运营可接受涨幅 */
  acceptableIncrease = undefined;

  /** 调整幅度 */
  adjustmentRange = undefined;

  /** AM（采购金额差值）采购金额差值 */
  amPrice = undefined;

  /** 申请调整单价（含税） */
  applyPurchaseQuotation = undefined;

  /** 审批结果 approved:通过 rejected:驳回 */
  approvalStatus = "";

  /** buCode */
  buCode = "";

  /** buName */
  buName = "";

  /** dprice */
  dprice = undefined;

  /** 原毛利率 */
  grossMargin = undefined;

  /** invoicingProductName */
  invoicingProductName = "";

  /** 近3月均销量 */
  monthlySales = undefined;

  /** 调整毛利率 */
  newGrossMargin = undefined;

  /** 调整售价（含税） */
  newPrice = undefined;

  /** 议价变化差异 */
  newPriceVariance = undefined;

  /** 议价采购单价（含税） */
  newPurchaseQuotation = undefined;

  /** 指导文件 */
  policyPaper = "";

  /** 指导价格 */
  policyPrice = undefined;

  /** 原销售价（含税） */
  price = undefined;

  /** 售价币种 */
  priceCurrency = "";

  /** 售价调整策略 0:不变、1:上调、2:下调 */
  priceStatus = undefined;

  /** 单价差异 */
  priceVariance = undefined;

  /** 调价申请单号 */
  pricingNo = "";

  /** 调整后采购成本率 */
  procurementCosts = undefined;

  /** productName */
  productName = "";

  /** 备注 */
  remark = "";

  /** 取样时间 */
  sampleDate = "";

  /** sku */
  sku = "";

  /** sku调价是否通过 0:不通过，1：通过 */
  skuPass = undefined;
}

class PrcocurementOrderWorkflowRequestDto {
  /** 审批结果 approved:通过 rejected:驳回 cancellation:作废 */
  approvalStatus = "";

  /** 审批备注 */
  approverRemark = "";

  /** 作废意见 */
  cancellationComment = "";

  /** 产品线运营主管 */
  operationExecutive = "";

  /** 采购调价申请单详情 */
  orderDetailsWorkflowRequestDtos = [];

  /** 毛利润明细表附件信息 */
  prcocurementStatementRequestDtos = [];

  /** 调价申请单号 */
  pricingNo = "";

  /** 驳回备注 */
  rejectedRemark = "";
}

class PrcocurementStatementRequestDto {
  /** 毛利润明细表名称 */
  fileName = "";

  /** 毛利润明细表附件信息 */
  fileUrl = "";
}

class ProcessBusinessDataResponseDto {
  /** 修改后数据 */
  afterUpdateData = "";

  /** 修改前数据 */
  beforeUpdateData = "";

  /** 工作流实例ID */
  instanceId = "";
}

class ProcurementOrderAndDetailsResponseDto {
  /** 调价类型,选项：procurement:采购调整、materials:物料调整 */
  adjustPriceType = "";

  /** 申请类型,选项：1:涨价调整、0:降价调整 */
  applyStatus = undefined;

  /** 提交人 */
  applyUser = "";

  /** 提交人提交时间 */
  applyUserTime = "";

  /** 审核状态 */
  approvalStatus = "";

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 审批备注 */
  approverRemark = "";

  /** 审批时间 */
  approverTime = "";

  /** 军团长 */
  armyGroup = "";

  /** 上传附件 */
  associatedFilesDetailResponseDtos = [];

  /** 毛利润明细表附件信息 */
  associatedFilesResponseDtos = [];

  /** 作废意见 */
  cancellationComment = "";

  /** 原因说明 */
  cause = "";

  /** 当前处理角色 */
  conductor = "";

  /** 所属军团 */
  corps = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** ECN变更申请号 */
  ecnPricingNo = "";

  /** 是否ECN变更,选项：1:是、0:否 */
  ecnStatus = undefined;

  /** id */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** sku是否已调价 0:否，1：是 */
  isAdjusted = undefined;

  /** 产品线运营主管 */
  operationExecutive = "";

  /** 调价申请单号 */
  pricingNo = "";

  /** 供应商ID */
  providerId = "";

  /** 调价原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** 采购调价申请单详情表 */
  responseDtos = [];

  /** SPU */
  spu = "";

  /** 申请状态：0：待提交，1：成本指导，2：采购议价，3：采购内审，4：运营调整，5：成本核实，6：层级审批，7：已完成，8：已作废 */
  status = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementOrderDetailsRequestDto {
  /** 运营可接受涨幅 */
  acceptableIncrease = undefined;

  /** 调整幅度 */
  adjustmentRange = undefined;

  /** AM（采购金额差值）采购金额差值 */
  amPrice = undefined;

  /** 申请调整单价（含税） */
  applyPurchaseQuotation = undefined;

  /** buCode */
  buCode = "";

  /** bu名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** dprice */
  dprice = undefined;

  /** 原毛利率 */
  grossMargin = undefined;

  /** id */
  id = undefined;

  /** 申报品名 */
  invoicingProductName = "";

  /** 近3月均销量 */
  monthlySales = undefined;

  /** 调整毛利率 */
  newGrossMargin = undefined;

  /** 调整售价（含税） */
  newPrice = undefined;

  /** 议价变化差异 */
  newPriceVariance = undefined;

  /** 议价采购单价（含税） */
  newPurchaseQuotation = undefined;

  /** 指导文件 */
  policyPaper = "";

  /** 指导价格 */
  policyPrice = undefined;

  /** 原销售价（含税） */
  price = undefined;

  /** 售价币种 */
  priceCurrency = "";

  /** 售价调整策略 0:不变、1:上调、2:下调 */
  priceStatus = undefined;

  /** 单价差异 */
  priceVariance = undefined;

  /** 调价申请单号 */
  pricingNo = "";

  /** 调整后采购成本率 */
  procurementCosts = undefined;

  /** 产品名称 */
  productName = "";

  /** 原采购报价（含税） */
  purchaseQuotation = undefined;

  /** 备注 */
  remark = "";

  /** SKU */
  sku = "";

  /** sku调价是否通过 0:不通过，1：通过 */
  skuPass = undefined;

  /** SKU状态  0:已作废，1：正常 */
  skuStatus = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementOrderDetailsResponseDto {
  /** 运营可接受涨幅 */
  acceptableIncrease = undefined;

  /** 调整幅度 */
  adjustmentRange = undefined;

  /** AM（采购金额差值）采购金额差值 */
  amPrice = undefined;

  /** 申请调整单价（含税） */
  applyPurchaseQuotation = undefined;

  /** buCode */
  buCode = "";

  /** bu名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** dprice */
  dprice = undefined;

  /** 原毛利率 */
  grossMargin = undefined;

  /** id */
  id = undefined;

  /** 申报品名 */
  invoicingProductName = "";

  /** 近3月均销量 */
  monthlySales = undefined;

  /** 调整毛利率 */
  newGrossMargin = undefined;

  /** 调整售价（含税） */
  newPrice = undefined;

  /** 议价变化差异 */
  newPriceVariance = undefined;

  /** 议价采购单价（含税） */
  newPurchaseQuotation = undefined;

  /** 指导文件 */
  policyPaper = "";

  /** 指导价格 */
  policyPrice = undefined;

  /** 原销售价（含税） */
  price = undefined;

  /** 售价币种 */
  priceCurrency = "";

  /** 售价调整策略 0:不变、1:上调、2:下调 */
  priceStatus = undefined;

  /** 单价差异 */
  priceVariance = undefined;

  /** 调价申请单号 */
  pricingNo = "";

  /** 调整后采购成本率 */
  procurementCosts = undefined;

  /** 产品名称 */
  productName = "";

  /** 原采购报价（含税） */
  purchaseQuotation = undefined;

  /** 备注 */
  remark = "";

  /** 取样时间 */
  sampleDate = "";

  /** SKU */
  sku = "";

  /** sku调价是否通过 0:不通过，1：通过 */
  skuPass = undefined;

  /** SKU状态 */
  skuStatus = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementOrderRequestDto {
  /** 调价类型,选项：procurement:采购调整、materials:物料调整 */
  adjustPriceType = "";

  /** 申请类型,选项：1:涨价调整、0:降价调整 */
  applyStatus = undefined;

  /** 提交人 */
  applyUser = "";

  /** 提交人提交时间 */
  applyUserTime = "";

  /** 审核状态 */
  approvalStatus = "";

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 审批备注 */
  approverRemark = "";

  /** 审批时间 */
  approverTime = "";

  /** 军团长 */
  armyGroup = "";

  /** 文件列表 */
  associatedFilesRequestDtos = [];

  /** 作废意见 */
  cancellationComment = "";

  /** 原因说明 */
  cause = "";

  /** 当前处理角色 */
  conductor = "";

  /** 所属军团 */
  corps = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** ECN变更申请号 */
  ecnPricingNo = "";

  /** 是否ECN变更,选项：1:是、0:否 */
  ecnStatus = undefined;

  /** id */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** sku是否已调价 0:否，1：是 */
  isAdjusted = undefined;

  /** 产品线运营主管 */
  operationExecutive = "";

  /** 调价申请单号 */
  pricingNo = "";

  /** 采购调价申请单详情 */
  procurementOrderDetailsRequestDtos = [];

  /** 供应商ID */
  providerId = "";

  /** 调价原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** SPU */
  spu = "";

  /** 申请状态：0：待提交，1：成本指导，2：采购议价，3：采购内审，4：运营调整，5：成本核实，6：层级审批，7：已完成，8：已作废 */
  status = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementOrderRequestParamsDto {
  /** 调价类型,选项：procurement:采购调整、materials:物料调整 */
  adjustPriceType = "";

  /** 申请类型,选项：1:涨价调整、0:降价调整 */
  applyStatus = undefined;

  /** 提交人 */
  applyUser = "";

  /** 提交人提交时间 */
  applyUserTime = "";

  /** 审核状态 */
  approvalStatus = "";

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 审批备注 */
  approverRemark = "";

  /** 审批时间 */
  approverTime = "";

  /** 审批开始时间 */
  approverTimeGe = "";

  /** 审批结束时间 */
  approverTimeLe = "";

  /** 作废意见 */
  cancellationComment = "";

  /** 当前处理角色 */
  conductor = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 申请单状态 */
  currentApprovalStep = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** ECN变更申请号 */
  ecnPricingNo = "";

  /** 是否ECN变更,选项：1:是、0:否 */
  ecnStatus = undefined;

  /** id */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** sku是否已调价 0:否，1：是 */
  isAdjusted = undefined;

  /** 产品线运营主管 */
  operationExecutive = "";

  /** 调价申请单号 */
  pricingNo = "";

  /** 供应商ID */
  providerId = "";

  /** 调价原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** SKU */
  sku = "";

  /** SPU */
  spu = "";

  /** 审批状态多选，英文逗号分隔 */
  status = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementOrderResponseDto {
  /** 调价类型,选项：procurement:采购调整、materials:物料调整 */
  adjustPriceType = "";

  /** 申请类型,选项：1:涨价调整、0:降价调整 */
  applyStatus = undefined;

  /** 提交人 */
  applyUser = "";

  /** 提交人提交时间 */
  applyUserTime = "";

  /** 审核状态 */
  approvalStatus = "";

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 审批备注 */
  approverRemark = "";

  /** 审批时间 */
  approverTime = "";

  /** 作废意见 */
  cancellationComment = "";

  /** 当前处理角色 */
  conductor = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 删除标识 */
  deleted = undefined;

  /** ECN变更申请号 */
  ecnPricingNo = "";

  /** 是否ECN变更,选项：1:是、0:否 */
  ecnStatus = undefined;

  /** id */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** sku是否已调价 0:否，1：是 */
  isAdjusted = undefined;

  /** 产品线运营主管 */
  operationExecutive = "";

  /** 调价申请单号 */
  pricingNo = "";

  /** 供应商ID */
  providerId = "";

  /** 调价原因 */
  reason = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人 */
  rejecter = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** SPU */
  spu = "";

  /** 申请状态：0：待提交，1：成本指导，2：采购议价，3：采购内审，4：运营调整，5：成本核实，6：层级审批，7：已完成，8：已作废 */
  status = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProcurementRemarkResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 调价申请单号 */
  pricingNo = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class PurchaseAgreementUrlResponseDto {
  /** 采购订单单号 */
  pono = "";

  /** 签署短链接 */
  shortUrl = "";

  /** 签署长链接 */
  url = "";
}

class PurchaseOrderAgreementRequestDto {
  /** 合同状态 0-草稿,1-签署中,2-完成,3-撤销,5-过期,7-拒签 */
  agreementStatus = [];

  /** ponos */
  ponos = [];
}

class PurchaseOrderDetailsDto {
  /** 可入库金额 */
  availableAmount = undefined;

  /** 可出库数量 */
  availableQty = undefined;

  /** 单据创建人 */
  billCreator = "";

  /** 箱数 */
  boxNumber = undefined;

  /** BU_code */
  buCode = "";

  /** BU_name */
  buName = "";

  /** 一级品类名称 */
  categoryName = "";

  /** 换货入库数量 */
  changedQty = undefined;

  /** 索赔行详情id */
  claimDetailId = undefined;

  /** 合同交期 */
  contractDeliveryTime = "";

  /** 合同交期修改标志 */
  contractDeliveryUpdateFlag = false;

  /** 军团名称 */
  corpsName = "";

  /** 币种 */
  currency = "";

  /** 数据修改类型: -1: 未修改, 1: 开票品名修改中, 2: 开票单位修改中, 4: 产品型号修改中 */
  dataModifyType = undefined;

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 已报关数量 */
  declaredQty = undefined;

  /** 可交货数量（总） */
  deliverableQuantity = undefined;

  /** 已交货金额 */
  deliveredAmount = undefined;

  /** 已交货数量 */
  deliveredQty = undefined;

  /** 已交货数量(不含换货) */
  deliveredQtyExcludeChanged = undefined;

  /** 已交货未入库金额 */
  deliveredUninboundAmount = undefined;

  /** 已交货未入库数量 */
  deliveredUninboundQty = undefined;

  /** 交货类型  0采购交货  1索赔交货 */
  deliveryType = undefined;

  /** 采购确定交期 */
  determineDeliveryTime = "";

  /** 停止交货状态: false: 正常交货, true: 停止交货 */
  endFlag = false;

  /** 采购单价(不含税) */
  excludeTaxUnitPrice = undefined;

  /** 现有库存 */
  existingStocks = undefined;

  /** 首批货好时间 */
  firstShipmentReadyTime = "";

  /** 是否已被索赔  0否  1是 */
  hasClaimed = undefined;

  /** id */
  id = undefined;

  /** 已入库金额 */
  inboundAmount = undefined;

  /** 已入库数量 */
  inboundQty = undefined;

  /** 入库时间 */
  inboundTime = "";

  /** 已入库总数包括换货数量 */
  inboundTotal = undefined;

  /** 开票品名 */
  invoiceName = "";

  /** 已开票数量 */
  invoicedQty = undefined;

  /** 是否为新增行 */
  isNew = undefined;

  /** MPQ */
  mpq = undefined;

  /** 已开票金额 */
  nvoicedAmount = undefined;

  /** 原定交期 */
  originalDeliveryTime = "";

  /** 回滚生成最原始的来源单号 */
  originalPrNo = "";

  /** 计划交货时间 */
  planDeliveryDate = "";

  /** PO单据NO */
  pono = "";

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理 */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 采购数量 */
  qty = undefined;

  /** 红冲发票金额 */
  redInvoiceAmount = undefined;

  /** 红冲发票数量 */
  redInvoiceQty = undefined;

  /** 已退款数量 */
  refundedQty = undefined;

  /** 备注 */
  remark = "";

  /** 已请款金额 */
  requestedAmount = undefined;

  /** 已请款数量 */
  requestedQty = undefined;

  /** 退货未入库的数量 */
  returnedButNoQty = undefined;

  /** 已退货数量 */
  returnedQty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** SKU型号 */
  skuModel = "";

  /** 来源PR单号 */
  sourceNo = "";

  /** 来源PR行号 */
  sourceRowNo = undefined;

  /** 税率 */
  taxRate = undefined;

  /** 总质检合格数量 */
  totalQualifiedQty = undefined;

  /** 可交货数量（未交货数量） */
  unDeliveredQty = undefined;

  /** 未入库金额 */
  unInboundAmount = undefined;

  /** 未入库数量 */
  unInboundQuantity = undefined;

  /** 可开票金额（未开票金额） */
  unInvoicedAmount = undefined;

  /** 可开票数量 */
  unInvoicedQty = undefined;

  /** 可请款金额 */
  unclaimedAmount = undefined;

  /** 可请款数量 */
  unclaimedQty = undefined;

  /** 产品单位Code */
  unitCode = "";

  /** 产品单位名称 */
  unitName = "";

  /** 采购单价 */
  unitPrice = undefined;

  /** 可退货数量 */
  unreturnedQty = undefined;
}

class PurchaseOrderRpcSrmResponseDto {
  /** 合同文件列表 */
  agreementDtos = [];

  /** 合同状态 0未生成 1已发出(别称未签署) 2已签署 */
  agreementStatus = undefined;

  /** 合同更新时间 */
  agreementUpdateTime = "";

  /** 可交货金额 */
  availableAmount = undefined;

  /** 可交货数量 */
  availableQty = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 单据创建人 */
  billCreator = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 账期/天 */
  dayNumber = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 已交货金额 */
  deliveredAmount = undefined;

  /** 已交货数量 */
  deliveredQty = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 入库金额 */
  inboundAmount = undefined;

  /** 入库数量 */
  inboundQty = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 计划员 */
  planner = "";

  /** PO单据NO */
  pono = "";

  /** 采购订单明细 */
  purchaseOrderDetails = [];

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 结算方式Code */
  settlementCode = "";

  /** 结算方式名称 */
  settlementName = "";

  /** 订单状态 */
  status = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 订单总额 */
  totalAmount = undefined;

  /** 采购总量 */
  totalQty = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PurchaseOrderSrmRequestDto {
  /** 合同状态 0未生成 1已生成(待签署) 2已签署 */
  agreementStatusIn = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** pages */
  pages = undefined;

  /** pono */
  pono = "";

  /** size */
  size = undefined;

  /** 供应商Code */
  supplierCode = "";
}

class PurchaseQuotationResponseDto {
  /** 审批状态:未调整、审批中、审批完成、已驳回 */
  approvalStatus = "";

  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** bu编号 */
  buCode = "";

  /** bu名称 */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 毛重（g） */
  grossWeight = undefined;

  /** 历史下单量 */
  historyOrderVolume = undefined;

  /** id */
  id = undefined;

  /** 开票品名 */
  invoicingProductName = "";

  /** 是否贴标 */
  lableFlag = false;

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（g） */
  netWeight = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购报价 */
  purchaseQuotation = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 阶梯报价列表 */
  quotationItemResponseDtoList = [];

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** spu */
  spu = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class RPCInDeliveryDetailBoxDto {
  /** 交货单单据NO */
  dono = "";

  /** sku集合 */
  skuList = [];

  /** 供应商ID */
  supplierIdName = "";
}

class RPCSupplierQuotationModel {
  /** 审批状态:未调整、审批中、审批完成、已驳回 */
  approvalStatus = "";

  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 毛重（g） */
  grossWeight = undefined;

  /** 历史下单量 */
  historyOrderVolume = undefined;

  /** id */
  id = undefined;

  /** 审批状态:待提交、审批中、审批完成、已驳回 */
  insertOrUpdateApprovalStatus = "";

  /** 状态，1：新增，2：修改 */
  insertOrUpdateStatus = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 开票品名 */
  invoicingProductName = "";

  /** 是否贴标 */
  lableFlag = false;

  /** 装载量20GP */
  loadCabinGpAmount = undefined;

  /** 装载量40HQ */
  loadCabinHqAmount = undefined;

  /** 装柜地址 */
  loadingAddressId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流员 */
  logisticsOwner = "";

  /** 物流服务更新人 */
  logisticsUpdateBy = "";

  /** 物流服务更新时间 */
  logisticsUpdateTime = "";

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（g） */
  netWeight = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购报价 */
  purchaseQuotation = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** spu */
  spu = "";

  /** 状态，1：启用，2：禁用，3：审批中，4：未启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class RcpCheckSupplierStatus {
  /** 供应商Code */
  supplierCode = [];
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new ChangeApprovalResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class RpcCheckWhetherExistsSettlementDto {
  /** 结算 */
  settlementMethodType = undefined;

  /** 供应商ID */
  supplierIdNames = [];
}

class RpcSkuSupplierQuotation {
  /** sku */
  skuList = [];

  /** 供应商ID */
  supplierIdNameList = [];
}

class RpcSupplierQuotationBySupplierIdNameList {
  /** 供应商ID */
  supplierIdNameList = [];
}

class SendEbsLog {
  /** errMsg */
  errMsg = "";

  /** success */
  success = false;

  /** supplierCode */
  supplierCode = "";

  /** supplierName */
  supplierName = "";
}

class SettlementMethodModelDto {
  /** 复选结算方式:installment:分期，freightCollectPayment:到付 */
  againTypeCode = "";

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 账期/天 */
  dayNumber = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 交货模式 */
  deliveryMode = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 结算方式类型: 1: 复购结算方式 2: 新品结算方式 */
  settlementMethodType = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 结算类型Code */
  typeCode = "";

  /** 结算类型名称 */
  typeName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SettlementMethodRequest {
  /** 复选结算方式:installment:分期，freight_collect_payment:到付 */
  againTypeCode = "";

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 账期/天 */
  dayNumber = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 结算方式类型: 1: 复购结算方式 2: 新品结算方式 */
  settlementMethodType = undefined;

  /** 结算方式 now_closed:现结 account_period:账期 */
  typeCode = "";

  /** 结算方式 now_closed:现结 account_period:账期 */
  typeName = "";
}

class SettlementMethodResponse {
  /** 尾款比例 */
  balanceRatio = undefined;

  /** 账期/天 */
  dayNumber = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 结算类型Code */
  settlementTypeCode = "";
}

class SettlementMethodResponseDto {
  /** 复选结算方式:installment:分期，freight_collect_payment:到付 */
  againTypeCode = "";

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 账期/天 */
  dayNumber = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 结算类型Code */
  settlementMethodType = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 结算类型Code */
  typeCode = "";

  /** 结算类型名称 */
  typeName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SkuAndSupplierIdNameRequestDto {
  /** sku */
  sku = "";

  /** supplierIdName */
  supplierIdName = "";
}

class SkuBoxInfo {
  /** 箱号 */
  boxNo = "";

  /** 装箱数量 */
  pickQty = undefined;
}

class SupplierAccountBoxInfoResponseDto {
  /** 每月剩余可下载箱数 */
  availableBoxNum = undefined;

  /** 箱码有效天数 */
  boxValidDays = undefined;

  /** 每月可下载箱数 */
  downloadBoxNum = undefined;

  /** 备注 */
  remark = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierAccountMasterResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 邮箱 */
  email = "";

  /** 手机号 */
  phone = "";

  /** 备注 */
  remark = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 更新时间 */
  updateTime = "";

  /** 用户名称 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierAccountPasswordRequestDto {
  /** 用户确认密码 */
  confirmPassword = "";

  /** 用户新密码 */
  newPassword = "";

  /** 用户原密码 */
  originalPassword = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierAccountRequestDto {
  /** 箱码有效天数 */
  boxValidDays = undefined;

  /** 每月可下载箱数 */
  downloadBoxNum = undefined;

  /** 每月可下载SN数 */
  downloadSnNum = undefined;

  /** 邮箱 */
  email = "";

  /** 手机号码 */
  phone = "";

  /** 备注 */
  remark = "";

  /** SN有效天数 */
  snValidDays = undefined;

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体名称 */
  transactionMainNameList = [];

  /** 供应商账号 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierAccountResponseDto {
  /** 每月剩余可下载箱数 */
  availableBoxNum = undefined;

  /** 每月剩余可下载SN数 */
  availableSnNum = undefined;

  /** 箱码有效天数 */
  boxValidDays = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 每月可下载箱数 */
  downloadBoxNum = undefined;

  /** 每月可下载箱数 */
  downloadSnNum = undefined;

  /** 邮箱 */
  email = "";

  /** 是否已平台认证 0否 1是 */
  isCertified = undefined;

  /** 手机号 */
  phone = "";

  /** 采购负责人 */
  purchaser = "";

  /** 是否推送采购订单 0否 1是 */
  pushPo = undefined;

  /** 备注 */
  remark = "";

  /** SN有效天数 */
  snValidDays = undefined;

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainNameList = [];

  /** 更新时间 */
  updateTime = "";

  /** 用户名称 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierAccountSnInfoResponseDto {
  /** 每月剩余可下载SN数 */
  availableSnNum = undefined;

  /** 每月可下载箱数 */
  downloadSnNum = undefined;

  /** 备注 */
  remark = "";

  /** SN有效天数 */
  snValidDays = undefined;

  /** 用户编号 */
  userNo = "";
}

class SupplierBankAccountModel {
  /** 收款账户名称 */
  accountName = "";

  /** 收款银行账户 */
  accountNumber = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierBankAccountRequestDto {
  /** 收款账户名称 */
  accountName = "";

  /** 收款银行账户 */
  accountNumber = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierBankAccountResponseDto {
  /** 收款账户名称 */
  accountName = "";

  /** 收款银行账户 */
  accountNumber = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierBankAccountUpdateRequestDto {
  /** 收款账户名称 */
  accountName = "";

  /** 收款银行账户 */
  accountNumber = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";
}

class SupplierBatchBoxBindSkuRequestDto {
  /** 箱子编号列表 */
  boxCodes = [];

  /** 箱高 */
  boxHigh = undefined;

  /** 箱长 */
  boxLength = undefined;

  /** 箱宽 */
  boxWidth = undefined;

  /** 单箱毛重 */
  grossWeight = undefined;

  /** 单箱净重 */
  netWeight = undefined;

  /** 装箱数量 */
  packQty = undefined;

  /** 产品名称 */
  productName = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";
}

class SupplierBatchDonoBindBoxRequestDto {
  /** 箱子编码 */
  boxCodes = [];

  /** 交货单单号 */
  dono = "";
}

class SupplierBatchSnBindRequestDto {
  /** pono */
  pono = "";

  /** rowNo */
  rowNo = undefined;

  /** SN码列表 */
  snnos = [];
}

class SupplierBoxAndSkuResponseDto {
  /** 逻辑箱码 */
  boxCode = "";

  /** 箱规-高 */
  boxHigh = undefined;

  /** 箱规-长 */
  boxLength = undefined;

  /** 箱规-宽 */
  boxWidth = undefined;

  /** 交货单单据NO */
  dono = "";

  /** FNSKU */
  fnsku = "";

  /** 单箱毛重 */
  grossWeight = undefined;

  /** MPQ */
  mpq = undefined;

  /** 单箱净重 */
  netWeight = undefined;

  /** 装箱数量 */
  packQty = undefined;

  /** 产品描述 */
  productDesc = "";

  /** 产品名称 */
  productName = "";

  /** SKU */
  sku = "";

  /** 产品图片 */
  skuImageUrl = "";
}

class SupplierBoxBatchResponseDto {
  /** 本次申请数量 */
  applyQty = undefined;

  /** 可用数量 */
  availableQty = undefined;

  /** 箱码批次号 */
  boxCodeBatchNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否启用: 0: 禁用 1: 启用 */
  enableFlag = undefined;

  /** 预计过期时间 */
  expectedExpiredTime = "";

  /** 过期时间 */
  expireDate = "";

  /** 是否超时作废: 1: 是 0: 否 */
  expiredFlag = undefined;

  /** 更新时间 */
  updateTime = "";

  /** 使用数量 */
  usedQty = undefined;

  /** 供应商用户编号 */
  userNo = "";
}

class SupplierBoxBindSkuRequestDto {
  /** 箱码 */
  boxCode = "";

  /** 箱高 */
  boxHigh = undefined;

  /** 箱长 */
  boxLength = undefined;

  /** 箱宽 */
  boxWidth = undefined;

  /** 单箱毛重 */
  grossWeight = undefined;

  /** 单箱净重 */
  netWeight = undefined;

  /** 装箱数量 */
  packQty = undefined;

  /** 产品名称 */
  productName = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";
}

class SupplierBoxGaugeUpdateRecordResponseDto {
  /** 箱高 */
  boxHigh = undefined;

  /** 箱长 */
  boxLength = undefined;

  /** 箱宽 */
  boxWidth = undefined;

  /** 单箱毛重 */
  grossWeight = undefined;

  /** 单箱净重 */
  netWeight = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** sku */
  sku = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商账户 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierBoxResponseDto {
  /** 绑定状态 1: 已绑定, 0: 未绑定 */
  bindFlag = undefined;

  /** 绑定时间 */
  bindTime = "";

  /** 箱码 */
  boxCode = "";

  /** 箱码批次号 */
  boxCodeBatchNumber = "";

  /** 箱高 */
  boxHigh = undefined;

  /** 箱长 */
  boxLength = undefined;

  /** 箱宽 */
  boxWidth = undefined;

  /** 交货单单号 */
  dono = "";

  /** 启用状态 1: 启用, 0: 禁用 */
  enableFlag = undefined;

  /** 单箱毛重 */
  grossWeight = undefined;

  /** 单箱净重 */
  netWeight = undefined;

  /** 装箱数量 */
  packQty = undefined;

  /** 产品名称 */
  productName = "";

  /** 发运状态 1: 已发运, 0: 未发运 */
  shipStatus = undefined;

  /** 发运时间 */
  shipTime = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** 使用状态 1: 已使用, 0: 未使用 */
  usedFlag = undefined;

  /** 用户编号 */
  userNo = "";
}

class SupplierBoxSkuResponseDto {
  /** 箱数 */
  boxNum = undefined;

  /** 装箱总数 */
  boxedQty = undefined;

  /** sku */
  sku = "";

  /** sku的装箱信息 */
  skuBoxInfos = [];
}

class SupplierBoxUpdateStatusDto {
  /** 交货单单号 */
  dono = "";
}

class SupplierContactsModel {
  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 邮箱 */
  email = "";

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 排序 */
  orders = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 职位 */
  title = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierContactsRequestDto {
  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 邮箱 */
  email = "";

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 排序 */
  order = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 职位 */
  title = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierContactsResponseDto {
  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 邮箱 */
  email = "";

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 排序 */
  orders = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 职位 */
  title = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierContactsUpdateRequestDto {
  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 邮箱 */
  email = "";

  /** 排序 */
  orders = undefined;

  /** 职位 */
  title = "";
}

class SupplierDeliveryOrderResponseDto {
  /** 已装箱总数 */
  boxedQty = undefined;

  /** 交货单 */
  dono = "";

  /** 采购负责人 */
  purchaser = "";

  /** 总数 */
  qty = undefined;

  /** 收货仓库Code */
  receiptWhCode = "";

  /** 收货仓库名称 */
  receiptWhName = "";

  /** 是否发运 */
  shipFlag = false;

  /** 交货单状态 */
  status = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商账号 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体 */
  transactionMainName = "";

  /** 更新时间 */
  updateTime = "";

  /** 供应商账号 */
  userNo = "";
}

class SupplierEbsRequestDto {
  /** supplierCode */
  supplierCode = [];
}

class SupplierHistoryPriceResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 价格类型 */
  priceTypeName = "";

  /** sku */
  sku = "";

  /** 报价 */
  stagePrices = "";

  /** 阶段范围 */
  stageRanges = "";

  /** 供应商Code */
  supplierCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierIdNameAndSkuDto {
  /** sku */
  sku = "";

  /** 供应IdName */
  supplierIdName = "";
}

class SupplierInfoAttachmentDto {
  /** 文件类型：供应商合同/供应商附件/sku附件/盖章采购合同 */
  fileCategory = "";

  /** 主体ID */
  id = undefined;

  /** 文件列表 */
  supplierFileList = [];

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";
}

class SupplierInfoFilesDto {
  /** ID */
  id = undefined;

  /** 文件列表 */
  supplierFileList = [];
}

class SupplierInfoListResponseDto {
  /** 注册地址 */
  address = "";

  /** 地址、电话 */
  addressAndPhone = "";

  /** 提交人 */
  applyUser = "";

  /** 审核状态 */
  approvalStatus = undefined;

  /** 收款账户名称 */
  bankAccountName = "";

  /** 收款银行账户 */
  bankAccountNumber = "";

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 当前处理角色 */
  conductor = "";

  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 交货模式 */
  deliveryMode = "";

  /** 分配状态，1：启用，2：禁用 */
  distributionState = undefined;

  /** 邮箱 */
  email = "";

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 法人 */
  legalPerson = "";

  /** 装柜地址 */
  loadingAddress = "";

  /** 通讯地址 */
  mailingAddress = "";

  /** 结算方式 */
  newSettlementTypeName = "";

  /** 采购负责人 */
  purchaser = "";

  /** 结算方式 */
  reSettlementTypeName = "";

  /** 备注 */
  remark = "";

  /** 结算类型Code */
  settlementTypeCode = "";

  /** sku种类数量 */
  skuNumber = undefined;

  /** 货源地 */
  sourceGoods = "";

  /** 状态，1：启用，2：禁用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商英文名 */
  supplierEnglishName = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商标识 */
  supplierIdentification = "";

  /** 装库地址 */
  supplierLoadingAddressList = [];

  /** 供应商名称 */
  supplierName = "";

  /** 供应商子类型 */
  supplierSubtypeCode = "";

  /** 供应商类型code */
  supplierTypeCode = "";

  /** 供应商类型名称 */
  supplierTypeName = "";

  /** 纳税人识别号 */
  taxNumber = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 主体ID */
  transactionMainId = undefined;

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierInfoModel {
  /** 注册地址 */
  address = "";

  /** 审核状态,-1：待提交、0:审批驳回 1:审批通过、2：创建审批中、10：变更审批中 */
  approvalStatus = undefined;

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 营业执照附件 */
  businessLicenseUrl = "";

  /** 供应商类别，0：外部供应商，1：内部供应商 */
  category = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 交货模式： 订单交货：orderDelivery   计划交货： plannedDelivery */
  deliveryMode = "";

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 是否已平台认证: 0否 1是 */
  isCertified = undefined;

  /** 法人 */
  legalPerson = "";

  /** 版本 */
  lockVersion = undefined;

  /** 开户行附件 */
  openingBankLicenseUrl = "";

  /** 其他附件 */
  otherUrl = "";

  /** 是否推送采购订单: 0否 1是 */
  pushPo = undefined;

  /** 备注 */
  remark = "";

  /** sku种类数量 */
  skuNumber = undefined;

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商联络人列表 */
  supplierContactsList = [];

  /** 供应商英文名 */
  supplierEnglishName = "";

  /** 供应商标识 */
  supplierIdentification = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商交易主体列表 */
  supplierOrganizationalUnitList = [];

  /** 供应商子类型，1:仓储供应商、2:物流TOB供应商、3:物流TOC供应商、4:其他服务类供应商 */
  supplierSubtypeCode = "";

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";

  /** 纳税人识别号 */
  taxNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierInfoRPCResponseDto {
  /** 注册地址 */
  address = "";

  /** 地址、电话 */
  addressAndPhone = "";

  /** 审核状态 */
  approvalStatus = undefined;

  /** 收款账户名称 */
  bankAccountName = "";

  /** 收款银行账户 */
  bankAccountNumber = "";

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 收款银行/支行 */
  bankName = "";

  /** 当前处理角色 */
  conductor = "";

  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 交货模式 */
  deliveryMode = "";

  /** 邮箱 */
  email = "";

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 通讯地址 */
  mailingAddress = "";

  /** 新品结算方式 */
  newProductSettlementMethod = new SettlementMethodResponse();

  /** 修改供应商信息新品结算方式 */
  newSettlementMethod = new NewSettlementMethodResponse();

  /** 采购负责人 */
  purchaser = "";

  /** 复购结算方式 */
  rePurchaseSettlementMethod = new SettlementMethodResponse();

  /** 修改供应商信息复购结算方式 */
  reSettlementMethod = new NewSettlementMethodResponse();

  /** 驳回备注 */
  rejectRemark = "";

  /** 备注 */
  remark = "";

  /** 结算类型Code */
  settlementTypeCode = "";

  /** sku种类数量 */
  skuNumber = undefined;

  /** 货源地 */
  sourceGoods = "";

  /** 状态，1：启用，2：禁用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 装库地址 */
  supplierLoadingAddressList = [];

  /** 供应商名称 */
  supplierName = "";

  /** 供应商类型code */
  supplierTypeCode = "";

  /** 供应商类型名称 */
  supplierTypeName = "";

  /** 纳税人识别号 */
  taxNumber = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierInfoRequestParamsDto {
  /** 审批状态多选，英文逗号分隔 */
  approvalStatus = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID列表，用英文逗号分隔 */
  idIn = "";

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** sku编号 */
  sku = "";

  /** 状态，1：启用，2：禁用，3：审批中 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdNameIn = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商子类型多选，英文逗号分隔，1:仓储供应商、2:物流TOB供应商、3:物流TOC供应商、4:其他服务类供应商 */
  supplierSubtypeCode = "";

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 更新时间-结束 */
  updateTimeEnd = "";

  /** 更新时间-开始 */
  updateTimeStart = "";
}

class SupplierInfoResponseDto {
  /** 注册地址 */
  address = "";

  /** 审核状态,-1：待提交、0:审批驳回 1:审批通过、2：创建审批中、10：变更审批中 */
  approvalStatus = undefined;

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 营业执照附件 */
  businessLicenseUrl = "";

  /** 是否能够发起线上合同，0：不可以发起，1：可以发起线上合同 */
  canOnlineAgreement = undefined;

  /** 供应商类别，0：外部供应商，1：内部供应商 */
  category = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 交货模式 */
  deliveryMode = "";

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 是否平台认证 */
  isCertified = undefined;

  /** 法人 */
  legalPerson = "";

  /** 版本 */
  lockVersion = undefined;

  /** 开户行附件 */
  openingBankLicenseUrl = "";

  /** 其他附件 */
  otherUrl = "";

  /** 是否推送采购订单，0否 1是 */
  pushPo = undefined;

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商联络人列表 */
  supplierContactsList = [];

  /** 供应商英文名 */
  supplierEnglishName = "";

  /** 供应商标识 */
  supplierIdentification = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商主体列表 */
  supplierOrganizationalUnitList = [];

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";

  /** 纳税人识别号 */
  taxNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierInfoSaveRequestDto {
  /** 注册地址 */
  address = "";

  /** 审核状态,-1：待提交、0:审批驳回 1:审批通过、2：创建审批中、10：变更审批中 */
  approvalStatus = undefined;

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 营业执照附件 */
  businessLicenseUrl = "";

  /** 供应商类别，0：外部供应商，1：内部供应商 */
  category = undefined;

  /** 交货模式： orderDelivery：订单交货   plannedDelivery：计划交货 */
  deliveryMode = "";

  /** ID */
  id = undefined;

  /** 法人 */
  legalPerson = "";

  /** 开户行附件 */
  openingBankLicenseUrl = "";

  /** 其他附件 */
  otherUrl = "";

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商联络人列表 */
  supplierContactsList = [];

  /** 供应商英文名 */
  supplierEnglishName = "";

  /** 供应商标识 */
  supplierIdentification = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商交易主体列表 */
  supplierOrganizationalUnitList = [];

  /** 供应商子类型，1:仓储供应商、2:物流TOB供应商、3:物流TOC供应商、4:其他服务类供应商 */
  supplierSubtypeCode = "";

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";

  /** 纳税人识别号 */
  taxNumber = "";
}

class SupplierInfoSpecifyDto {
  /** 审核状态,-1：待提交、0:审批驳回 1:审批通过、2：创建审批中、10：变更审批中 */
  approvalStatus = undefined;

  /** ID */
  id = undefined;

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商子类型，1:仓储供应商、2:物流TOB供应商、3:物流TOC供应商、4:其他服务类供应商 */
  supplierSubtypeCode = "";

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";
}

class SupplierInfoUpdateRequestDto {
  /** 注册地址 */
  address = "";

  /** 审核状态,-1：待提交、0:审批驳回 1:审批通过、2：创建审批中、10：变更审批中 */
  approvalStatus = undefined;

  /** 开户行及账号 */
  bankAndAccount = "";

  /** 营业执照附件 */
  businessLicenseUrl = "";

  /** 供应商类别，0：外部供应商，1：内部供应商 */
  category = undefined;

  /** 供应商联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 交货模式 */
  deliveryMode = "";

  /** ID */
  id = undefined;

  /** 工作流实例id */
  instanceId = "";

  /** 法人 */
  legalPerson = "";

  /** 开户行附件 */
  openingBankLicenseUrl = "";

  /** 其他附件 */
  otherUrl = "";

  /** 备注 */
  remark = "";

  /** 结算类型Code */
  settlementTypeCode = "";

  /** sku种类数量 */
  skuNumber = undefined;

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商联络人列表 */
  supplierContactsList = [];

  /** 供应商英文名 */
  supplierEnglishName = "";

  /** 供应商标识 */
  supplierIdentification = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商交易主体列表 */
  supplierOrganizationalUnitList = [];

  /** 供应商子类型，1:仓储供应商、2:物流TOB供应商、3:物流TOC供应商、4:其他服务类供应商 */
  supplierSubtypeCode = "";

  /** 供应商类型,F:成品、M:生产性物料、E:非生产性物料、P:外协加工、S:服务类 */
  supplierTypeCode = "";

  /** 纳税人识别号 */
  taxNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierLoadingAddressResponseDto {
  /** id */
  id = undefined;

  /** 装柜地址 */
  loadingAddress = "";
}

class SupplierLoadingAddressUpdateRequestDto {
  /** 装柜地址 */
  loadingAddress = "";
}

class SupplierOrganizationalUnitModel {
  /** 通讯地址 */
  address = "";

  /** 地址、电话 */
  addressAndPhone = "";

  /** 地址编码(预留,ebs概念) */
  addressCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 货源地 */
  sourceGoods = "";

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商银行账户 */
  supplierBankAccountModelList = [];

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierOrganizationalUnitRequestDto {
  /** 地址、电话 */
  addressAndPhone = "";

  /** 地址编码(预留,ebs概念) */
  addressCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 结算方式Code now_closed:现结 account_period:账期 */
  settlementTypeCode = "";

  /** 货源地 */
  sourceGoods = "";

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierOrganizationalUnitResponseDto {
  /** 通讯地址 */
  address = "";

  /** 地址、电话 */
  addressAndPhone = "";

  /** 地址编码(预留,ebs概念) */
  addressCode = "";

  /** 是否能够发起线上合同，0：不可以发起，1：可以发起线上合同 */
  canOnlineAgreement = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 交货模式 */
  deliveryMode = "";

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 新品结算方式 */
  newProductSettlementMethod = new SettlementMethodResponseDto();

  /** 采购负责人 */
  purchaser = "";

  /** 复购结算方式 */
  rePurchaseSettlementMethod = new SettlementMethodResponseDto();

  /** 备注 */
  remark = "";

  /** 货源地 */
  sourceGoods = "";

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 银行账户列表 */
  supplierBankAccountModelList = [];

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 装柜地址列表 */
  supplierLoadingAddressList = [];

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SupplierOrganizationalUnitUpdateRequestDto {
  /** 通讯地址 */
  address = "";

  /** 地址、电话 */
  addressAndPhone = "";

  /** 地址编码(预留,ebs概念) */
  addressCode = "";

  /** 币种 */
  currency = "";

  /** 是否包邮 */
  freeShippingFlag = false;

  /** ID */
  id = undefined;

  /** 新品结算方式 */
  newProductSettlementMethod = new SettlementMethodRequest();

  /** 采购负责人 */
  purchaser = "";

  /** 复购结算方式 */
  rePurchaseSettlementMethod = new SettlementMethodRequest();

  /** 备注 */
  remark = "";

  /** 货源地 */
  sourceGoods = "";

  /** 状态，0：停用，1：启用 */
  status = undefined;

  /** 银行账户列表 */
  supplierBankAccountModelList = [];

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 装柜地址列表 */
  supplierLoadingAddressList = [];

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class SupplierPoSkuSnBindStatisticsResponseDto {
  /** PO单号 */
  pono = "";

  /** 是否产品化管理 */
  productManageFlag = false;

  /** 采购数量 */
  purchaseQty = undefined;

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** po-sku绑定SN的数量 */
  snBindQty = undefined;
}

class SupplierPurchaseRatioApplyRequestDto {
  /** 备注 */
  remark = "";

  /** sku */
  sku = "";
}

class SupplierPurchaseRatioDetailsRequestDto {
  /** 调整后下单比例 */
  afterOrderRatio = undefined;

  /** 供应商ID=Code+交易主体缩写 */
  supplierIdName = "";

  /** 供应商名 */
  supplierName = "";
}

class SupplierPurchaseRatioDetailsResponseDto {
  /** 调整后下单比例 */
  afterOrderRatio = undefined;

  /** 原下单比例 */
  beforeOrderRatio = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 采购比例审批单据NO */
  purchaseRatioNo = "";

  /** sku */
  sku = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierPurchaseRatioResponseDto {
  /** 审批状态：审批中、已驳回、审批通过 */
  approvalStatus = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 采购比例详情 */
  purchaseRatioList = [];

  /** 采购比例审批单据NO */
  purchaseRatioNo = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierPurchaseRatioUpdateRequestDto {
  /** 采购比例详情 */
  purchaseRatioList = [];

  /** sku编码 */
  sku = "";
}

class SupplierPushPoRequestDto {
  /** 是否推送采购订单 0否 1是 */
  pushPo = undefined;

  /** 用户编号 */
  userNo = "";
}

class SupplierQuotationDetailsDto {
  /** 币种 */
  currency = "";

  /** 交货模式 */
  deliveryMode = "";

  /** 结束范围 */
  endRange = undefined;

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 价格类型 */
  priceTypeCode = "";

  /** 是否产品化管理 */
  productManageFlag = false;

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购报价 */
  purchasePrice = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** sku */
  sku = "";

  /** 开始范围 */
  startRange = undefined;

  /** 供应商code */
  supplierCode = "";

  /** 供应商ID */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class SupplierQuotationItemResponseDto {
  /** 结算范围 */
  endRange = undefined;

  /** id */
  id = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 采购报价 */
  purchasePrice = undefined;

  /** sku */
  sku = "";

  /** 开始范围 */
  startRange = undefined;

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";
}

class SupplierQuotationLocalResponseDto {
  /** 审批状态:未调整、审批中、审批完成、已驳回 */
  approvalStatus = "";

  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 毛重（g） */
  grossWeight = undefined;

  /** 历史下单量 */
  historyOrderVolume = undefined;

  /** id */
  id = undefined;

  /** 新增或修改审批状态:待提交、审批中、审批完成、已驳回、修改驳回 */
  insertOrUpdateApprovalStatus = "";

  /** 审批流程类型:1 新增 2 修改 */
  insertOrUpdateStatus = undefined;

  /** 流程实例id */
  instanceId = "";

  /** 开票品名 */
  invoicingProductName = "";

  /** 是否贴标 */
  lableFlag = false;

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（g） */
  netWeight = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购报价 */
  purchaseQuotation = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** sku报价明细 */
  quotationPriceList = [];

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** spu */
  spu = "";

  /** 状态，1：启用，2：禁用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierQuotationPriceRequestDto {
  /** 结束范围 */
  endRange = undefined;

  /** 采购报价 */
  purchasePrice = undefined;

  /** 开始范围 */
  startRange = undefined;
}

class SupplierQuotationPriceResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 结算范围 */
  endRange = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 采购报价 */
  purchasePrice = undefined;

  /** sku */
  sku = "";

  /** 开始范围 */
  startRange = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierQuotationRequestDto {
  /** 审批状态:未调整、审批中、审批完成、已驳回 */
  approvalStatus = "";

  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** 币种 */
  currency = "";

  /** 毛重（kg） */
  grossWeight = undefined;

  /** id */
  id = undefined;

  /** 新增或修改审批状态:待提交、审批中、审批完成、已驳回、修改驳回 */
  insertOrUpdateApprovalStatus = "";

  /** 状态:1 新增 2 修改 */
  insertOrUpdateStatus = undefined;

  /** 开票品名 */
  invoicingProductName = "";

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（kg） */
  netWeight = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** sku报价明细 */
  quotationPriceList = [];

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** spu */
  spu = "";

  /** 状态，1：启用，2：禁用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class SupplierQuotationResponseDto {
  /** 审批状态:未调整、审批中、审批完成、已驳回 */
  approvalStatus = "";

  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 是否申报型号 */
  declareTypeFlag = undefined;

  /** 毛重（g） */
  grossWeight = undefined;

  /** 历史下单量 */
  historyOrderVolume = undefined;

  /** id */
  id = undefined;

  /** 新增或修改审批状态:待提交、审批中、审批完成、已驳回、修改驳回 */
  insertOrUpdateApprovalStatus = "";

  /** 审批流程类型:1 新增 2 修改 */
  insertOrUpdateStatus = undefined;

  /** 流程实例id */
  instanceId = "";

  /** 开票品名 */
  invoicingProductName = "";

  /** 是否贴标 */
  lableFlag = false;

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（g） */
  netWeight = undefined;

  /** 下单比例 */
  orderRatio = undefined;

  /** 价格类型Code：固定报价、按数量下单阶梯 */
  priceTypeCode = "";

  /** 产品描述 */
  productDesc = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 采购报价 */
  purchaseQuotation = undefined;

  /** 采购负责人 */
  purchaser = "";

  /** sku报价明细 */
  quotationPriceList = [];

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 图片 */
  skuImageUrl = "";

  /** 产品型号 */
  skuModel = "";

  /** spu */
  spu = "";

  /** 状态，1：启用，2：禁用 */
  status = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 税率 */
  taxRate = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SupplierQuotationResultDto {
  /** 尾款比例 */
  balanceRatio = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** sku报价 */
  price = undefined;

  /** sku */
  sku = "";

  /** 供应商编号 */
  supplierCode = "";

  /** 供应商ID */
  supplierIdName = "";
}

class SupplierQuotationSearchDto {
  /** sku列表 */
  skuList = [];
}

class SupplierQuotationSearchSkuDto {
  /** sku */
  sku = "";
}

class SupplierQuotationUpdateRequestDto {
  /** 开票品名 */
  invoicingProductName = "";

  /** 是否产品化管理（SN） */
  productManageFlag = false;

  /** 产品名称 */
  productName = "";

  /** 单位 */
  productUnit = "";

  /** 采购负责人 */
  purchaser = "";

  /** sku */
  sku = "";
}

class SupplierSnBatchResponseDto {
  /** 申请数量 */
  applyQty = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 批次到期时间 */
  expectedExpiredTime = "";

  /** 过期标志 */
  expiredFlag = false;

  /** 修改时间 */
  updateTime = "";

  /** 已使用数量 */
  usedQty = undefined;

  /** 供应商账号 */
  userNo = "";

  /** SN码批次号 */
  zsnno = "";
}

class SupplierSnBindRequestDto {
  /** pono */
  pono = "";

  /** rowNo */
  rowNo = undefined;

  /** SN码 */
  snno = "";
}

class SupplierSnInfoResponseDto {
  /** 创建时间 */
  createTime = "";

  /** 过期标志 1: 已过期, 0: 未过期 */
  expiredFlag = false;

  /** pono */
  pono = "";

  /** 采购员 */
  purchaser = "";

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** sn编号 */
  snno = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改时间 */
  updateTime = "";

  /** 使用状态 1: 已使用, 0: 未使用 */
  usedFlag = false;

  /** 供应商账号 */
  userNo = "";

  /** SN码批次 */
  zsnno = "";
}

class SupplierSnOperateResponseDto {
  /** 操作时间 */
  createTime = "";

  /** 操作类型 */
  operate = "";

  /** 操作类型说明 */
  operateMsg = "";

  /** PO单号 */
  pono = "";

  /** SN码 */
  snno = "";
}

class SupplierSnResponseDto {
  /** po单号 */
  pono = "";

  /** 行号 */
  rowNo = undefined;

  /** sku */
  sku = "";

  /** sn码 */
  snno = "";

  /** 使用状态 1: 已使用, 0: 未使用 */
  usedFlag = false;
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class UserDto {
  /** clientCode */
  clientCode = "";

  /** clientList */
  clientList = [];

  /** clientType */
  clientType = "ADMIN";

  /** jobNo */
  jobNo = "";

  /** jti */
  jti = "";

  /** password */
  password = "";

  /** scope */
  scope = [];

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class UserResourceDto {
  /** accessToken */
  accessToken = "";

  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** appResources */
  appResources = [];

  /** clientCode */
  clientCode = "";

  /** clientType */
  clientType = "ADMIN";

  /** expiresIn */
  expiresIn = undefined;

  /** jobNo */
  jobNo = "";

  /** jti */
  jti = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** userCode */
  userCode = "";

  /** userName */
  userName = "";

  /** userResources */
  userResources = [];
}

class ViewLogisticsSkuResponseDto {
  /** 箱规高（cm） */
  boxHigh = undefined;

  /** 箱规长（cm） */
  boxLength = undefined;

  /** 箱规宽（cm） */
  boxWidth = undefined;

  /** 品牌名称 */
  brandName = "";

  /** BU */
  buCode = "";

  /** BU_Name */
  buName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 毛重（g） */
  grossWeight = undefined;

  /** 产品高 */
  heightCm = undefined;

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 装柜属性: 10标准件 20大件 30超大件 */
  loadCabinAttribute = undefined;

  /** 装载量20GP */
  loadCabinGpAmount = undefined;

  /** 装载量40HQ */
  loadCabinHqAmount = undefined;

  /** 装柜地址 */
  loadingAddressList = [];

  /** 物流员 */
  logisticsOwner = "";

  /** 物流服务更新人 */
  logisticsUpdateBy = "";

  /** 物流服务更新时间 */
  logisticsUpdateTime = "";

  /** 产品长 */
  longCm = undefined;

  /** MOQ */
  moq = undefined;

  /** MPQ */
  mpq = undefined;

  /** 净重（g） */
  netWeight = undefined;

  /** 计划员 */
  planner = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 采购负责人 */
  purchaser = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 单个产品装箱体积重(m3) */
  singleBoxVolumeWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** sku */
  sku = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 货源地 */
  sourceGoods = "";

  /** 产品编号 */
  spu = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 交易主体NsCode */
  transactionMainNsCode = "";

  /** 产品类型名称 */
  typeName = "";

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ViewLogisticsSkuUpdateRequestDto {
  /** id不能为空 */
  id = undefined;

  /** 装载量20GP */
  loadCabinGpAmount = undefined;

  /** 装载量40HQ */
  loadCabinHqAmount = undefined;

  /** sku */
  sku = "";

  /** 供应商idName */
  supplierIdName = "";
}

export const srm = {
  AgreementDto,
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  AssigneeDto,
  AssociatedFileCategoryDto,
  AssociatedFileDto,
  AssociatedFilesRequestDto,
  AssociatedFilesResponseDto,
  BaseApprovalRequestDto,
  ChangeApprovalRequestDto,
  ChangeApprovalResponseDto,
  CheckSupplierCodeRequestDto,
  CheckWhetherExistsSettlementDto,
  Client,
  ClientDto,
  Code,
  CurrentTaskDto,
  DailyBound,
  DailyBoundSnDetailsResponseDto,
  EcBusinessNoFlowResponseRpcDto,
  IPage,
  InDeliveryDetailBoxRequestDto,
  InDetailPDAReceivingRequestDto,
  LoginExchangeDto,
  NewSettlementMethodResponse,
  OrderDetailsWorkflowRequestDto,
  PadQuerySnResponseDto,
  PrcocurementOrderDetailsWorkflowRequestDto,
  PrcocurementOrderWorkflowRequestDto,
  PrcocurementStatementRequestDto,
  ProcessBusinessDataResponseDto,
  ProcurementOrderAndDetailsResponseDto,
  ProcurementOrderDetailsRequestDto,
  ProcurementOrderDetailsResponseDto,
  ProcurementOrderRequestDto,
  ProcurementOrderRequestParamsDto,
  ProcurementOrderResponseDto,
  ProcurementRemarkResponseDto,
  PurchaseAgreementUrlResponseDto,
  PurchaseOrderAgreementRequestDto,
  PurchaseOrderDetailsDto,
  PurchaseOrderRpcSrmResponseDto,
  PurchaseOrderSrmRequestDto,
  PurchaseQuotationResponseDto,
  RPCInDeliveryDetailBoxDto,
  RPCSupplierQuotationModel,
  RcpCheckSupplierStatus,
  Response,
  ResponseDto,
  RpcCheckWhetherExistsSettlementDto,
  RpcSkuSupplierQuotation,
  RpcSupplierQuotationBySupplierIdNameList,
  SendEbsLog,
  SettlementMethodModelDto,
  SettlementMethodRequest,
  SettlementMethodResponse,
  SettlementMethodResponseDto,
  SkuAndSupplierIdNameRequestDto,
  SkuBoxInfo,
  SupplierAccountBoxInfoResponseDto,
  SupplierAccountMasterResponseDto,
  SupplierAccountPasswordRequestDto,
  SupplierAccountRequestDto,
  SupplierAccountResponseDto,
  SupplierAccountSnInfoResponseDto,
  SupplierBankAccountModel,
  SupplierBankAccountRequestDto,
  SupplierBankAccountResponseDto,
  SupplierBankAccountUpdateRequestDto,
  SupplierBatchBoxBindSkuRequestDto,
  SupplierBatchDonoBindBoxRequestDto,
  SupplierBatchSnBindRequestDto,
  SupplierBoxAndSkuResponseDto,
  SupplierBoxBatchResponseDto,
  SupplierBoxBindSkuRequestDto,
  SupplierBoxGaugeUpdateRecordResponseDto,
  SupplierBoxResponseDto,
  SupplierBoxSkuResponseDto,
  SupplierBoxUpdateStatusDto,
  SupplierContactsModel,
  SupplierContactsRequestDto,
  SupplierContactsResponseDto,
  SupplierContactsUpdateRequestDto,
  SupplierDeliveryOrderResponseDto,
  SupplierEbsRequestDto,
  SupplierHistoryPriceResponseDto,
  SupplierIdNameAndSkuDto,
  SupplierInfoAttachmentDto,
  SupplierInfoFilesDto,
  SupplierInfoListResponseDto,
  SupplierInfoModel,
  SupplierInfoRPCResponseDto,
  SupplierInfoRequestParamsDto,
  SupplierInfoResponseDto,
  SupplierInfoSaveRequestDto,
  SupplierInfoSpecifyDto,
  SupplierInfoUpdateRequestDto,
  SupplierLoadingAddressResponseDto,
  SupplierLoadingAddressUpdateRequestDto,
  SupplierOrganizationalUnitModel,
  SupplierOrganizationalUnitRequestDto,
  SupplierOrganizationalUnitResponseDto,
  SupplierOrganizationalUnitUpdateRequestDto,
  SupplierPoSkuSnBindStatisticsResponseDto,
  SupplierPurchaseRatioApplyRequestDto,
  SupplierPurchaseRatioDetailsRequestDto,
  SupplierPurchaseRatioDetailsResponseDto,
  SupplierPurchaseRatioResponseDto,
  SupplierPurchaseRatioUpdateRequestDto,
  SupplierPushPoRequestDto,
  SupplierQuotationDetailsDto,
  SupplierQuotationItemResponseDto,
  SupplierQuotationLocalResponseDto,
  SupplierQuotationPriceRequestDto,
  SupplierQuotationPriceResponseDto,
  SupplierQuotationRequestDto,
  SupplierQuotationResponseDto,
  SupplierQuotationResultDto,
  SupplierQuotationSearchDto,
  SupplierQuotationSearchSkuDto,
  SupplierQuotationUpdateRequestDto,
  SupplierSnBatchResponseDto,
  SupplierSnBindRequestDto,
  SupplierSnInfoResponseDto,
  SupplierSnOperateResponseDto,
  SupplierSnResponseDto,
  TaskDto,
  UserDto,
  UserResourceDto,
  ViewLogisticsSkuResponseDto,
  ViewLogisticsSkuUpdateRequestDto,
};
